export default [{
  text: '',
  items: [
    { icon: 'mdi-view-dashboard-outline', key: 'menu.dashboard', text: 'Dashboard', link: '/'  }
  ]
},{
  text: 'メインメニュー',
  items: [
    { icon: 'mdi-cards-outline', text: '在庫一覧', link: '/stocks' },
    { text: 'カード関連',
      items: [
        { icon: 'mdi-card-plus-outline', text: 'カード登録', link: '/register-card' },
        { icon: 'mdi-format-list-bulleted', text: 'カード一覧', link: '/view-cards' },
        { icon: 'mdi-card-search-outline', text: 'カード検索', link: '/search-card' },
      ]
    },
    { text: '買取関連',
      items: [
        { icon: 'mdi-store-plus-outline', text: '買取一覧', link: '/view-entries' },
        { icon: 'mdi-history', text: '買取履歴', link: '/search-entries' },
        { icon: 'mdi-table-arrow-right', text: '買取表作成', link: '/choice-purchase-items' },
      ]
    },
    { text: '出庫関連',
      items: [
        { icon: 'mdi-store-minus-outline', text: '出庫一覧', link: '/view-exits' },
        { icon: 'mdi-history', text: '出庫履歴', link: '/search-exits' },
      ]
    },
    { text: '会計関連',
      items: [
        { text: '貸借対照表', link: '/view-exits' },
        { text: '総勘定元帳', link: '/view-exits' },
        { text: '残高試算表', link: '/view-exits' },
        { text: '損益計算書', link: '/view-exits' },
        { text: 'C/F計算書', link: '/view-exits' },
      ]
    }
  ]
}]
